module.exports = __webpack_public_path__ + "static/media/CT_2019_30450A.f465769f.png";